import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  padding-block: 20px;
  padding-inline: 24px;

  border: 2px solid #ffca05;
`;

export const Text = styled.div`
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 25px;
`;

export const StyledBaseLink = styled(BaseLink)`
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 18.8px;
  text-align: center;

  border-radius: 4px;

  background-color: #4585ff;
`;
